import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Pay } from './pay';

export const getTokenResolver: ResolveFn<boolean> = async (route, state) => {
  const payService = inject(Pay);
  const token = route.queryParamMap.get('token') || payService.hashToken;
  if (!token) {
    payService.backToBroker();
    throw new Error('Token Not Valid');
  }

  payService.hashToken = token;
  const jwtToken = await payService.getJWTToken(token);

  if (!jwtToken) {
    payService.showErrorDialog();
    throw new Error('Token Not Valid');
  }

  payService.getAssets();
  payService.getTerminalInfo();

  return true;
};
